import { render, staticRenderFns } from "./DarkModeSwitch.vue?vue&type=template&id=2e3d01bb&scoped=true&"
import script from "./DarkModeSwitch.vue?vue&type=script&lang=ts&"
export * from "./DarkModeSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./DarkModeSwitch.vue?vue&type=style&index=0&id=2e3d01bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3d01bb",
  null
  
)

export default component.exports